import { useState } from "react";
import { Loader2, Clock } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";

export const BulkHours = ({ selected, total, onToggleAll, onApplied }) => {
  const [hours, setHours] = useState("");
  const [saving, setSaving] = useState(false);

  const apply = async (e) => {
    e.preventDefault();
    if (!selected.length) return toast.error("Marcá al menos un punto");
    setSaving(true);
    try {
      await api.patch("/admin/agencies/hours", { ids: selected, hours });
      toast.success(`Horario aplicado a ${selected.length} punto(s)`);
      onApplied(hours.trim());
      setHours("");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={apply} data-testid="bulk-hours-form" className="mt-6 rounded-2xl bg-[var(--forest)] p-5 text-white">
      <p className="flex items-center gap-2 font-display-up text-lg"><Clock className="h-5 w-5 text-[var(--lime)]" /> Cargar horario a varios puntos a la vez</p>
      <div className="mt-3 flex flex-col gap-3 sm:flex-row">
        <Input data-testid="bulk-hours-input" value={hours} onChange={(e) => setHours(e.target.value)} required placeholder="Ej. Lun a Dom 6 a 23 hs" className="h-12 rounded-xl bg-white text-[var(--ink)] sm:flex-1" />
        <button data-testid="bulk-hours-apply" disabled={saving} className="flex h-12 items-center justify-center gap-2 rounded-xl bg-[var(--lime)] px-6 font-bold text-[var(--ink)]">
          {saving && <Loader2 className="h-4 w-4 animate-spin" />} Aplicar a {selected.length}
        </button>
      </div>
      <button type="button" onClick={onToggleAll} data-testid="bulk-hours-toggle-all" className="mt-3 text-sm font-semibold underline underline-offset-4">
        {selected.length === total ? "Desmarcar todos" : `Marcar los ${total}`}
      </button>
    </form>
  );
};
